import { createReducer, on } from '@ngrx/store';
import { appInitialState } from '@store/states/app.state';
import { appActions } from '@store/actions/app.actions';

export const appReducer = createReducer(
  appInitialState,
  on(appActions.showLoading, (state) => ({ ...state, showLoading: true })),
  on(appActions.hideLoading, (state) => ({ ...state, showLoading: false })),
  on(appActions.showCustomLoading, (state, { loading }) => ({
    ...state,
    specificLoading: [...state.specificLoading, loading],
  })),
  on(appActions.hideCustomLoading, (state, { loading }) => ({
    ...state,
    specificLoading: [...state.specificLoading.filter((value) => value != loading)],
  })),
  on(appActions.visitedHeader, (state, { header }) => ({
    ...state,
    visitedHeaderNotifications: {
      ...state.visitedHeaderNotifications,
      [header]: true,
    },
  })),
  on(appActions.enableScroll, (state) => ({
    ...state,
    blockedScroll: false,
  })),
  on(appActions.disableScroll, (state) => ({
    ...state,
    blockedScroll: true,
  })),
  on(appActions.setCookiesConsent, (state, cookiesConsent) => ({
    ...state,
    cookiesConsent: {
      ...cookiesConsent,
    },
  }))
);
